<portal-modal (clickedOutside)="onClose()">
	<div modalHeader class="mb-6">
		<ng-content select="[audioPreviewerTitle]"></ng-content>
	</div>
	<div modalContent class="mb-6">
		<ng-content select="[audioPreviewerElement]"></ng-content>
	</div>
	<div modalFooter class="flex justify-end">
		<button
			type="button"
			(click)="onClose()"
			[ngClass]="appStateService.product?.Route === productRoute.HOLD ? 'blue-bg' : 'purple-bg'"
			class="text-white !w-auto focus:ring-blue-300 hover:bg-blue-800 focus:ring-4 font-medium rounded text-sm px-5 py-2.5"
		>
			Dismiss
		</button>
	</div>
</portal-modal>
